module.exports = __webpack_public_path__ + "static/media/msg-icon-off.c24bbfaa.svg";